// @flow

import React from "react";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import Option from "./Option";
import { Options as StyledOptions } from "./styles";

type Props = {
  options: Array<string>,
  handleRemoveOption: (string) => void,
  isMultiple: boolean,
  defaultValue: string[],
  setDefaultValue: (string[]) => void,
  onEdit: (string, string) => void,
};

const Options = ({
  options,
  handleRemoveOption,
  isMultiple,
  defaultValue,
  setDefaultValue,
  onEdit,
}: Props) => {
  if (options.length === 0) return null;

  const ids = options.map((option, index) => `option-${index}`);

  return (
    <SortableContext items={ids} strategy={verticalListSortingStrategy}>
      <StyledOptions>
        {options.map((option, index) => (
          <Option
            key={`${option}-${index}`}
            id={ids[index]}
            option={option}
            onRemove={handleRemoveOption}
            isMultiple={isMultiple}
            setDefaultValue={setDefaultValue}
            onEdit={onEdit}
            isDefault={(defaultValue ?? []).includes(option)}
          />
        ))}
      </StyledOptions>
    </SortableContext>
  );
};

export default Options;
